import React, { Component } from "react";
import Delete from '../../../../assets/img/svg/delete.svg';
import del from "../../../../assets/img/svg/Del.svg";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import { CssTextFieldLast, CssTextFieldRow } from "../../../custom/textField"

// ********* type id's *********
const scope1 = 403;
const scope2 = 404;
const scope3 = 405;
const ghgreduction = 407;

class LViewCFP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            HoverId: 0,
            HoverId1: 0,
            index1: 0,
            isMobile: false,
            render: false,
            dataList: [],
            deleteId: 0,
            showrow: false,
            responseId: 0,
            index: 0,
            actNameFocus: false,
            DescNameFocus: false,
            name: "",
            typeId: [],
            nameError: false,
            rolesValue: [],
            trainingsOptions: [],
            dataListCommon: [],
            trainingsDisplay: [],
            HoverIdCommon: 0,
            FocusIdCommon: 0,
            isDisabled: false,
            trainingChange: false,
            trainingChangeRoles: [],
            paging: false,
            existId: [],
            isOnChange: false,
            emissionFactor: "",
            newName: "",
            newEmissionFactor: null,
            newEmissionFactorError: false,
            newNameError: false,
            typeId: null,
            emissionData: []
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const userRole = localStorage.getItem("UserRoles");
        this.setState({ paging: true });
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable();
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#MASDATA10 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData10 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#MasterData1010").addClass("d-none");
        $("#MasterData1010").removeClass("d-block");
        $("#MCFP").removeClass("active-color");
        $("#MCFPT").removeClass("fw-bolder");
    }

    dataTable = () => {
        let apiUrl = API.CFP_MASTERDATA;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.emissionData = response.data;
                        // setTimeout(
                        //     window.scrollTo(0, 0)
                        //     , 0)
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    handleInputAdditionalCFP = (e, str, val, index) => {
        this.setState({
            isOnChange: true,
        })
        var pattern = /^\d{0,5}(?:\.\d{0,6})?$/

        if (val == "Name") {
                this.state?.emissionData?.map((i) => (
                    i.Id == str.Id ? i.Name = e.target.value : <></>
                ))
        }

        if (val == "emissionFactor") {
            if (pattern.test(e.target.value)) {
                this.state?.emissionData?.map((i) => (
                    i.Id == str.Id ? i.EmissionFactor = e.target.value : <></>
                ))
            }
             
        }

        if (e.target.value != "") {
            let index = this.state.existId.filter(item => item !== str.Id);
            this.setState({
                existId: index
            })
        }
        this.setState({})
    }

    async postDataBlur(e, str, val) {
        this.setState({
            nameError: true
        })
        let dataName = e.target.value?.trim();
        if (this.state.isOnChange == true) {
            this.setState({
                isOnChange: false
            })
            if (dataName?.length > 0 && str.Id != 0) {
                let index = this.state.existId.filter(item => item !== str.Id);
                this.setState({
                    existId: index
                })
                 if (str.Id != 0) {
                    let data = {
                        "Id": str.Id,
                        "Name": str.Name,
                        "TypeId": str.TypeId,
                        "EmissionFactor": str.EmissionFactor
                    }
                    this.put_data(data, str.Id)
                }
            }
            this.setState({})
        } else {
            this.setState({
                HoverId: 0,
                index: 0
            })
        }
    }

    async postDataBlurEmissionFactor(e, str, val) {

        let dataName = e.target.value?.trim();
        if (this.state.isOnChange == true) {
            this.setState({
                isOnChange: false
            })
            if (dataName?.length > 0 && str.Id != 0) {

                let index = this.state.existId.filter(item => item !== str.Id);
                this.setState({
                    existId: index
                })
            
                if (str.Id != 0) {
                    let data = {
                        "Id": str.Id,
                        "Name": str.Name,
                        "TypeId": str.TypeId,
                        "EmissionFactor": parseFloat(str.EmissionFactor)
                    }
                    this.put_data(data, str.Id)
                }
            }
            this.setState({})
        } else {
            this.setState({
                HoverId1: 0,
                index1: 0
            })
        }
    }

    addNewData = (e, val, typeId) => {
        var NewPattern = /^\d{0,5}(?:\.\d{0,6})?$/
        this.setState({ typeId : typeId })
        if (val === "Name") {
                if(e.target?.value.trim() !== ""){
                    this.setState({
                        newName :  e.target?.value,
                        newNameError: false
                    })
                } else {
                    if(this.state.newEmissionFactor?.length > 0){
                        this.setState({
                            newName : "",
                            newNameError: true
                        })
                    } else {
                         this.setState({
                            newName: "",
                            newNameError: false,
                            newEmissionFactorError: false
                         })
                    }
                   
            }
          
        } else if (val === "emissionFactor") {

            if(NewPattern.test(e.target.value)){
                if(e.target?.value?.length > 0){
                    this.setState({
                        newEmissionFactor :  e.target?.value,
                        newEmissionFactorError: false
                    })
                } else {
                
    
                    if(this.state.newName?.trim() !== ""){
                        this.setState({
                            newEmissionFactor : null,
                            newEmissionFactorError: true
                        })
                    } else {
                         this.setState({
                            newEmissionFactor: null,
                            newNameError: false,
                            newEmissionFactorError: false
                         })
                    }
    
                }
            } 
         
        }
    }

    
    postNewData = (e, val, typeId) => {
        this.setState({ typeId : typeId })
       if(this.state.newName?.trim() !== "" && this.state.newEmissionFactor?.length > 0) {
        let data = {
            "Id": 0,
            "Name": this.state.newName,
            "TypeId": typeId,
            "EmissionFactor": parseFloat(this.state.newEmissionFactor)
        }
        this.put_data(data)
        this.setState({
            newEmissionFactorError : false ,
            newNameError : false,
            newName: "",
        newEmissionFactor: ""
            })
         
       } else if (this.state.newName?.trim() !== "" && (this.state.newEmissionFactor?.length == 0 || this.state.newEmissionFactor == null)  ) {
        this.setState({
           newEmissionFactorError : true ,
           newNameError : false
        })

       }  else if (this.state.newName?.trim() == "" && this.state.newEmissionFactor?.length > 0) {
       this.setState({
        newNameError : true,
        newEmissionFactorError: false
       })
       }  else {
        this.setState({
            newEmissionFactorError : false ,
            newNameError : false
         })
       }
    }

    put_data = (data) => {
        let apiUrl = API.CFP_MASTERDATA ;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable()
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };

    onFocusCFP = (typeid) => {
        
        this.setState({
            newNameError: false,
            newEmissionFactorError: false,
        })

      if (this.state.typeId == typeid) {

      } else {
        this.setState({
            newName : "",
            newEmissionFactor : null,
            typeId: typeid
        })
      }
    }


    OpenPopup = (Id) => {
        this.setState({ deleteId : Id })
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deleteopalookdocs(this.state.deleteId)
    }

    deleteopalookdocs = (data) => {
        let apiUrl = API.CFP_MASTERDATA + '?requestId=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable()
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#MASDATA10 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData10 .MuiListItemText-primary").addClass("fw-bolder");
        $("#MasterData1010").removeClass("d-none");
        $("#MasterData1010").addClass("d-block");
        $("#MCFPT .MuiListItemText-primary").addClass("fw-bolder");
        $("#MCFP").addClass("active-color");
    };

    sidebar = () => {
        this.props.navigate("/sidebarmasterdata");
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id="MASDATA10" className='  textNaviIcon' primary="Master Data" />
                                            <NavigateNextIcon id="MASDATA1010" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Carbon Foot print</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>

                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Carbon Foot print</h6>}
                            </div>
                        </div>

                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-1" style={{ width: "100%" }}>
                                <span className="spandoc-thead">Scope 1 Emissions</span>
                                <div className="table-scroll">
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right mt-3">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="49%" style={{ minWidth: '49%', maxWidth: '49%' }}><span className="spandoc-thead">Source</span></th>
                                            <th className="border-top border-right" width="48%" style={{ minWidth: '48%', maxWidth: '48%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Emission factor / tCO2e</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody className="scroll-15">
                                      
                                            <>{this.state?.emissionData.filter((item) => item.TypeId == scope2) && this.state?.emissionData?.map((i, index) => (
                                                (i.Id != 0 && i.TypeId == scope1) ?
                                                    <tr className="border-top" key={i.Id + "scope1"}>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left span-height`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={(this.state.HoverId == i.Id || this.state.index == i.Id || this.state.existId?.includes(i.Id) == true || (i.Name?.trim()?.length == 0)) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId: 0 , index : 0})}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index: i.Id, typeId : scope1 })}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, i, 'Name', index)}
                                                                    onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                    value={i.Name && i.Name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            </div>
                                                            {(((i.Name?.trim()?.length == 0))) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Source is required</span> : <></>}
                                                        </td>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left span-height`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={(this.state.HoverId1 == i.Id || this.state.index1 == i.Id || this.state.existId?.includes(i.Id) == true || (i.EmissionFactor?.length == 0 || i.EmissionFactor == null)) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actDesc" + i.Id}
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId1: 0 , index1 : 0})}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index1: i.Id, typeId : scope1})}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, i, 'emissionFactor', index)}
                                                                    onBlur={(e) => this.postDataBlurEmissionFactor(e, i, 'emissionFactor')}
                                                                    value={i.EmissionFactor && i.EmissionFactor}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            </div>
                                                            {(((i.EmissionFactor?.length == 0 || i.EmissionFactor == null))) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Emission factor is required</span> : <></>}
                                                        </td>
                                                        <td className="align-middle text-center border-right"><img src={Delete} className={this.state.isDisabled ? "img-disabled" : "cursorPointer"} onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                    </tr> : <></>
                                            ))}
                                              
                                                        <tr className="border-top">
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    onChange={(e) => this.addNewData(e,'Name', scope1)}
                                                                    onBlur={(e) => this.postNewData(e,'Name', scope1)}
                                                                    onFocus={(e) => {this.onFocusCFP(scope1)}}
                                                                    value={this.state.typeId == scope1 ? this.state.newName : ""}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {(this.state.newNameError == true && this.state.typeId == scope1) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Source is required</span> : <></>}
                                                            </td>
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    onFocus={(e) => this.onFocusCFP(scope1) }
                                                                    onChange={(e) => this.addNewData(e,'emissionFactor', scope1)}
                                                                    onBlur={(e) => this.postNewData(e,'emissionFactor', scope1)}
                                                                    value={(this.state.typeId == scope1) ? ( this.state.newEmissionFactor ? this.state.newEmissionFactor : "" ) : null}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {(this.state.newEmissionFactorError == true && this.state.typeId == scope1) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Emission factor is required</span> : <></>}
                                                            </td>
                                                            <td className="align-middle text-center border-right">
                                                            </td>
                                                        </tr> </>
                                    </tbody>
                                </table>
                                </div>
                            </div>

                        </div>

                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-1" style={{ width: "100%" }}>
                                <span className="spandoc-thead">Scope 2 Emissions</span>
                                <div className="table-scroll">
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right mt-3">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="49%" style={{ minWidth: '49%', maxWidth: '49%' }}><span className="spandoc-thead">Source</span></th>
                                            <th className="border-top border-right" width="48%" style={{ minWidth: '48%', maxWidth: '48%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Emission factor / tCO2e</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody className="scroll-15">
                                       
                                            <>{this.state?.emissionData.filter((item) => item.TypeId == scope2) && this.state?.emissionData?.map((i, index) => (
                                                (i.Id != 0 && i.TypeId == scope2) ?
                                                    <tr className="border-top" key={i.Id + "scope2"}>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left span-height`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={(this.state.HoverId == i.Id || this.state.index == i.Id || this.state.existId?.includes(i.Id) == true || (i.Name?.trim()?.length == 0)) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId: 0 , index : 0})}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index: i.Id, typeId : scope2 })}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, i, 'Name', index)}
                                                                    onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                    value={i.Name && i.Name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            </div>
                                                            {(((i.Name?.trim()?.length == 0))) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Source is required</span> : <></>}
                                                        </td>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left span-height`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={(this.state.HoverId1 == i.Id || this.state.index1 == i.Id || this.state.existId?.includes(i.Id) == true || (i.EmissionFactor?.length == 0 || i.EmissionFactor == null)) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId1: 0 , index1 : 0})}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index1: i.Id, typeId : scope2})}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, i, 'emissionFactor', index)}
                                                                    onBlur={(e) => this.postDataBlurEmissionFactor(e, i, 'emissionFactor')}
                                                                    value={i.EmissionFactor && i.EmissionFactor}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            </div>
                                                            {(((i.EmissionFactor?.length == 0 || i.EmissionFactor == null))) ?
                                                                    <span className="" style={{ color: '#DD0000' }}>Emission factor is required</span> : <></>}
                                                        </td>
                                                        <td className="align-middle text-center border-right"><img src={Delete} className={this.state.isDisabled ? "img-disabled" : "cursorPointer"} onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                    </tr> : <></>
                                            ))}
                                              </>
                                            <tr className="border-top">
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    onChange={(e) => this.addNewData(e,'Name', scope2)}
                                                                    onBlur={(e) => this.postNewData(e,'Name', scope2)}
                                                                    onFocus={(e) => this.onFocusCFP(scope2)}
                                                                    value={this.state.typeId == scope2 ? this.state.newName : ""}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {(this.state.newNameError == true && this.state.typeId == scope2) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Source is required</span> : <></>}
                                                            </td>
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    onFocus={(e) => this.onFocusCFP(scope2)}
                                                                    onChange={(e) => this.addNewData(e,'emissionFactor', scope2)}
                                                                    onBlur={(e) => this.postNewData(e,'emissionFactor', scope2)}
                                                                    value={this.state.typeId == scope2 ? ( this.state.newEmissionFactor ? this.state.newEmissionFactor : "" )  : null}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {(this.state.newEmissionFactorError == true && this.state.typeId == scope2) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Emission factor is required</span> : <></>}
                                                            </td>
                                                            <td className="align-middle text-center border-right">
                                                            </td>
                                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-1" style={{ width: "100%" }}>
                                <span className="spandoc-thead">Scope 3 Emissions</span>
                                <div className="table-scroll">
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right mt-3">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="49%" style={{ minWidth: '49%', maxWidth: '49%' }}><span className="spandoc-thead">Source</span></th>
                                            <th className="border-top border-right" width="48%" style={{ minWidth: '48%', maxWidth: '48%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Emission factor / tCO2e</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody className="scroll-15">
                                      
                                            <>{this.state?.emissionData.filter((item) => item.TypeId == scope3) && this.state?.emissionData?.map((i, index) => (
                                                (i.Id != 0 && i.TypeId == scope3) ?
                                                    <tr className="border-top" key={i.Id + "scope3"}>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left span-height`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={(this.state.HoverId == i.Id || this.state.index == i.Id || this.state.existId?.includes(i.Id) == true || (i.Name?.trim()?.length == 0)) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId: 0 , index : 0})}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index: i.Id, typeId : scope3 })}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, i, 'Name', index)}
                                                                    onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                    value={i.Name && i.Name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            </div>
                                                            {(((i.Name?.trim()?.length == 0))) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Source is required</span> : <></>}
                                                        </td>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left span-height `} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={(this.state.HoverId1 == i.Id || this.state.index1 == i.Id || this.state.existId?.includes(i.Id) == true || (i.EmissionFactor?.length == 0 || i.EmissionFactor == null)) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actDesc" + i.Id}
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId1: 0 , index1 : 0})}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index1: i.Id, typeId : scope3})}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, i, 'emissionFactor', index)}
                                                                    onBlur={(e) => this.postDataBlurEmissionFactor(e, i, 'emissionFactor')}
                                                                    value={i.EmissionFactor && i.EmissionFactor}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            </div>
                                                            {(((i.EmissionFactor?.length == 0 || i.EmissionFactor == null))) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Emission factor is required</span> : <></>}
                                                        </td>
                                                        <td className="align-middle text-center border-right"><img src={Delete} className={this.state.isDisabled ? "img-disabled" : "cursorPointer"} onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                    </tr> : <></>
                                            ))}
                                               
                                                      </>
                                                      <tr className="border-top">
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left `} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id="actName"
                                                                    onChange={(e) => this.addNewData(e,'Name', scope3)}
                                                                    onBlur={(e) => this.postNewData(e,'Name', scope3)}
                                                                    onFocus={(e) => this.onFocusCFP(scope3)}
                                                                    value={this.state.typeId == scope3 ? this.state.newName : ""}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {(this.state.newNameError == true && this.state.typeId == scope3) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Source is required</span> : <></>}
                                                            </td>
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id="actDesc"
                                                                    onFocus={(e) => this.onFocusCFP(scope3)}
                                                                    onChange={(e) => this.addNewData(e,'emissionFactor',scope3)}
                                                                    onBlur={(e) => this.postNewData(e,'emissionFactor', scope3)}
                                                                    value={this.state.typeId == scope3 ? ( this.state.newEmissionFactor ? this.state.newEmissionFactor : "" )  : null}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {(this.state.newEmissionFactorError == true && this.state.typeId == scope3) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Emission factor is required</span> : <></>}
                                                            </td>
                                                            <td className="align-middle text-center border-right">
                                                            </td>
                                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-1" style={{ width: "100%" }}>
                                <h6 className="mb-3">GHG Reduction:</h6>
                                <span className="spandoc-thead">Estimated GHG Emissions During New Production of Steel and Other Components</span>
                                <div className="table-scroll">
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right mt-3">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="49%" style={{ minWidth: '49%', maxWidth: '49%' }}><span className="spandoc-thead">Source</span></th>
                                            <th className="border-top border-right" width="48%" style={{ minWidth: '48%', maxWidth: '48%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Emission factor / tCO2e</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody className="scroll-15">
                                        {this.state?.emissionData.filter((item) => item.TypeId == ghgreduction) &&
                                            <>{this.state?.emissionData?.map((i, index) => (
                                                (i.Id != 0 && i.TypeId == ghgreduction) &&
                                                    <tr className="border-top" key={i.Id + "GHG1"}>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left span-height `} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={(this.state.HoverId == i.Id || this.state.index == i.Id || this.state.existId?.includes(i.Id) == true || (i.Name?.trim()?.length == 0)) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId: 0, index : 0 })}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index: i.Id, typeId : ghgreduction })}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, i, 'Name', index)}
                                                                    onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                    value={i.Name && i.Name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            </div>
                                                            {(((i.Name?.trim()?.length == 0))) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Source is required</span> : <></>}
                                                        </td>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left span-height `} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={(this.state.HoverId1 == i.Id || this.state.index1 == i.Id || this.state.existId?.includes(i.Id) == true || (i.EmissionFactor?.length == 0 || i.EmissionFactor == null)) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actDesc" + i.Id}
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId1: 0, index1 : 0 })}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index1: i.Id, typeId : ghgreduction })}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, i, 'emissionFactor', index)}
                                                                    onBlur={(e) => this.postDataBlurEmissionFactor(e, i, 'emissionFactor')}
                                                                    value={i.EmissionFactor && i.EmissionFactor}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            </div>
                                                            {(((i.EmissionFactor?.length == 0 || i.EmissionFactor == null))) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Emission factor is required</span> : <></>}
                                                        </td>
                                                        <td className="align-middle text-center border-right"><img src={Delete} className={this.state.isDisabled ? "img-disabled" : "cursorPointer"} onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                    </tr> 
                                            ))}
                                             
                                                     </> 
                                            }
                                               <tr className="border-top">
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left `} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id="actName"
                                                                    onChange={(e) => this.addNewData(e,'Name', ghgreduction)}
                                                                    onBlur={(e) => this.postNewData(e,'Name', ghgreduction)}
                                                                    onFocus={(e) => this.onFocusCFP(ghgreduction)}
                                                                    value={this.state.typeId == ghgreduction ? this.state.newName : ""}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {(this.state.newNameError == true && this.state.typeId == ghgreduction) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Source is required</span> : <></>}
                                                            </td>
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id="actDesc"
                                                                    onFocus={(e) => this.onFocusCFP(ghgreduction)}
                                                                    onChange={(e) => this.addNewData(e,'emissionFactor', ghgreduction)}
                                                                    onBlur={(e) => this.postNewData(e,'emissionFactor', ghgreduction)}
                                                                    value={this.state.typeId == ghgreduction ? ( this.state.newEmissionFactor ? this.state.newEmissionFactor : "" )  : null}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {(this.state.newEmissionFactorError == true && this.state.typeId == ghgreduction) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Emission factor is required</span> : <></>}
                                                            </td>
                                                            <td className="align-middle text-center border-right">
                                                            </td>
                                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LViewCFP))
);
